import React from "react";
import { Link } from "gatsby"
import resolveLink from "src/utils/resolveLink"

const ArrowButton = ({children, className, to, target, activeClassName, onClick}) => {
    const classes = `font-display text-brightgreen font-semibold text-sm tracking-[-0.03em] inline-flex flex-row items-center ${
        className ? className : ""
    }`
    const innerContent = 
    <>
        {children}
        <i class="fa-solid fa-arrow-right text-sm mt-1 ml-1.5 group-hover:ml-3 duration-300"></i>
    </>
    return children ? (
        // If there is no target/link just output a div. This is to prevent the nested <a> problem
        !to ?
        <div className={`${classes}`}>
            {innerContent}
        </div>
        // If the target is a non-gatsby target
        : to.includes('tel:') || to.includes('mailto:') || target === '_blank' ?
            <a 
                className={`${classes}`}
                href={to}
                target={target}
            >
                {innerContent}
            </a>
        // Default
        :
            <Link
                className={`${classes}`}
                to={resolveLink(to)}
                activeClassName={activeClassName ? activeClassName : ""}
                onClick={onClick ? onClick : ""}
            >
                {innerContent}
            </Link>
    )
    : ''
};

export default ArrowButton;
